package com.evoapps.evoshift.data.dto.finance

import com.evoapps.evoshift.data.dto.system.MetadataDto
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdjustmentDto(
    val id: String = "",
    val rosterId: String,
    val userId: String,

    val type: AdjustmentTypeDto,
    val amount: Double,
    val currency: String,

    val date: String,
    val description: String,
    val relatedShiftId: String? = null,
    val metadata: MetadataDto
)

@Serializable
enum class AdjustmentTypeDto {
    @SerialName("BONUS")
    BONUS,

    @SerialName("DEDUCTION")
    DEDUCTION,

    @SerialName("EXPENSE_REFUND")
    EXPENSE_REFUND
}